<div class="quest-dialog">
    <div class="ml-auto w-full text-right justify-end -mt-4 -mr-3">
        <button id="closeModalChangeStatus2" mat-icon-button (click)="closeModal()" tabindex="-1">
            <mat-icon class="text-primary">close</mat-icon>
        </button>
    </div>

    <div class="pb-2 text-center title-text-modal">
        {{ 'candidateShareCFLink' | translate }}
    </div>

    <div class="md:px-6 px-0 pt-3">
        <p class="descriptionDuplicateText">
            {{ 'candidateShareCFLinkMessage' | translate:{vacancyName: vacancyName, candidateName: candidateName} }}
        </p>

        <!-- Asunto -->
        <div class="py-1 w-full">
            <label class="pr-6 input-text">
                {{ 'candidateCFEmailTo' | translate }}
            </label>
            <div class="flex items-center w-full mt-1 border p-2 centered-text brown-border rounded-lg">
                <span class="text-gray-600 text-sm">{{email}}</span>
            </div>
        </div>

        <!-- Asunto -->
        <div class="py-1 w-full">
            <label class="pr-6 input-text">
                {{ 'changeStatusSubject' | translate }}:
            </label>
            <div class="flex items-center w-full mt-1 border p-2 centered-text brown-border rounded-lg">
                <span class="text-gray-600 text-sm">Queremos conocerte mejor</span>
            </div>
        </div>

        <!-- Mensaje -->
        <div class="py-1 w-full">
            <label class="pr-6 input-text">
                {{ 'changeStatusMessage' | translate }}:
            </label>
            <div class="flex items-center w-full mt-1 border p-2 centered-text brown-border rounded-lg">
                <span class="text-gray-600 text-sm">
                    Hola, {{ candidateName }}: <br>
                    Te enviamos este cuestionario para saber más de ti: <span class="text-primary underline">Ir al cuestionario</span> <br>
                    Quedamos en espera.
                    <br>
                    <br>
                    {{ userName }}
                </span>
            </div>
        </div>

        <div class="mt-4 w-full flex justify-center">
            <app-custom-primary-button id="saveQuestions" type="submit" size="filter-size" color="primary"
                class="text-center mx-auto" [textPadding]="'20px'" [textAlign]="'inherit'" (click)="sendQuest()">
                <div class="w-full flex justify-center gap-2">
                    <mat-spinner *ngIf="sending" diameter="20" color="primary"></mat-spinner>
                    <span class="btn-label">{{ 'saveShareCandidates' | translate }}</span>
                </div>
            </app-custom-primary-button>
        </div>
    </div>
</div>